/* ==========================================================================
   "You may also like" — carga por la Section Rendering API.
   Shopify calcula las recomendaciones en su endpoint; el render inicial llega
   vacío y se rellena con esta petición (patrón nativo, sin apps).
   ========================================================================== */

(function () {
  'use strict';

  function load(el) {
    if (!el || !el.dataset.url || el.dataset.loaded === '1') return;
    el.dataset.loaded = '1';

    fetch(el.dataset.url)
      .then(function (r) { return r.text(); })
      .then(function (html) {
        // DOMParser no ejecuta scripts, y en vez de asignar innerHTML se importan
        // los nodos ya parseados: mismo resultado sin pasar por el sink.
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-related]');
        if (!fresh) return;
        while (el.firstChild) el.removeChild(el.firstChild);
        var kids = Array.prototype.slice.call(fresh.childNodes);
        for (var i = 0; i < kids.length; i++) {
          el.appendChild(document.importNode(kids[i], true));
        }
      })
      .catch(function () {
        /* sin recomendaciones no se pinta nada: la sección queda vacía y oculta */
      });
  }

  function boot() {
    var nodes = document.querySelectorAll('[data-related]');
    for (var i = 0; i < nodes.length; i++) load(nodes[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();
